import { supabaseClient } from "@/lib/supabase";

export type SendPhoneOtpResponse = { ok: true } | { ok: false; error: string; code: string };

/** Server verifies profile + auth phone, then sends SMS OTP via Edge (service role). */
export async function invokePublicSendPhoneOtp(phone: string): Promise<void> {
    const trimmed = phone.trim();
    const { data, error } = await supabaseClient.functions.invoke<SendPhoneOtpResponse>("public-send-phone-otp", {
        body: { phone: trimmed },
    });
    if (error) {
        throw new Error(error.message);
    }
    if (!data?.ok) {
        const err = new Error(data.error);
        Object.assign(err, { code: data.code });
        throw err;
    }
}
